<template>
    <section class="section-quotes light--bg-blue">
        <div class="row max-width-md section-title pb-3 pt-6">
            <div class="col-12">
                <i class="fas fa-quote-right quotes--icon" alt=""></i><br />
                <h2 class="quotes--title">Nuestros clientes hablan de nosotros</h2>
            </div>
        </div>

        <slide-pagination class="max-width-md layout-quotes" />
    </section>
</template>
<script>
import SlidePagination from '@/components/slide-pagination.vue';

export default {
    name: "SectionProyectos",
    components: {
        SlidePagination
    }
}
</script>
<style lang="scss">
.section-quotes {
    min-height: 530px;
    height: 100%;

    @media (max-width: 1280px) {
        padding: 60px;
    }

    .quotes--title {
        font-weight:normal;
        margin:2rem 0px 0px;
    }

    .quotes--icon {
        font-size: 60px;
        color: $light--blue;
    }
    
    .layout-quotes {
        flex-direction: column;
        padding:30px 0px !important;
    }
}
</style>